import React from "react";
import sharedStyles from "../styles/SharedStyles.module.css";
import caveEntrance from "../assets/cave_entrance.png";

const Index = ({ enterRoom1 }) => {
  return (
    <div className={sharedStyles.centeredContainer}>
      <h1 className={sharedStyles.pageTitle}>The Cave Entrance</h1>
      <p className={sharedStyles.pageDescription}>
        Cold air seeps from the darkness ahead. The stone path descends into silence.
      </p>

      <div className={sharedStyles.sceneContainer}>
        {/* Scene Image */}
        <img
          src={caveEntrance}
          alt="Cave Entrance"
          className={sharedStyles.sceneImage}
        />

        {/* Enter Button */}
        <button
          className={sharedStyles.button}
          style={{ top: "62%", left: "48%", position: "absolute" }}
          onClick={enterRoom1}
        >
          Enter
        </button>
      </div>
    </div>
  );
};

export default Index;